export default __webpack_public_path__ + "static/media/Img0014.49ed7aed.png";